/**
 * LiveToggle
 *
 * SCAN（連続認識）モードのON/OFFトグル。
 * - OFF状態: 「SCAN」表示、押すと SCAN 開始
 * - ON状態 : 「STOP」表示＋pulse、押すと SCAN 停止
 */

import styles from './LiveToggle.module.css';

export interface LiveToggleProps {
  /** SCANモードが有効か */
  isScanning: boolean;
  onStart: () => void;
  onStop: () => void;
  /** 利用不可（カメラ未起動・APIキー未設定など） */
  disabled?: boolean;
}

export function LiveToggle({ isScanning, onStart, onStop, disabled = false }: LiveToggleProps) {
  const handleClick = () => {
    if (isScanning) {
      onStop();
    } else {
      onStart();
    }
  };

  return (
    <button
      type="button"
      className={`${styles.root} ${isScanning ? styles.rootActive : ''}`}
      onClick={handleClick}
      disabled={disabled}
      aria-label={isScanning ? '連続認識を停止' : '連続認識を開始'}
      aria-pressed={isScanning}
    >
      {isScanning ? '⏹ STOP' : 'SCAN'}
    </button>
  );
}
